module.exports = {
    // This is for legacy purposes - avoid adding to this for new settings
    oneSite: {
        maxCharactersPersonalShopperNote: 100,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/onesite.js